import { Component } from '@angular/core';

@Component({
  selector: 'app-submit-feedback',
  standalone: true,
  imports: [],
  templateUrl: './submit-feedback.component.html',
  styleUrl: './submit-feedback.component.scss'
})
export class SubmitFeedbackComponent {

}
